var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3877 36.5639L9.3134 39.4936C7.44504 40.5722 5.05598 39.9322 3.97727 38.0638L2.02414 34.6809C0.945627 32.8126 1.58567 30.4236 3.45403 29.3449L8.52834 26.4152L14.3877 36.5639Z",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3877 36.5635L32.5405 32.8487L20.8218 12.5513L8.52832 26.4147L14.3877 36.5635Z",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.71 48.1773C16.3087 48.9864 14.517 48.5062 13.708 47.105L9.31348 39.4934L14.3877 36.5637L18.7822 44.1753C19.5914 45.5765 19.1112 47.3683 17.71 48.1773Z",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2729 34.1177L20.0894 11.283",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2463 13.2188H38.3167",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2463 7.35938H38.3167",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6877 25.3281H35.6799L39.0385 28.7174C38.8874 29.1882 38.8049 29.6898 38.8049 30.2109C38.8049 32.9076 40.9911 35.0938 43.6877 35.0938C46.3844 35.0938 48.5706 32.9076 48.5706 30.2109C48.5706 27.5143 46.3844 25.3281 43.6877 25.3281Z",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7815 1.5C34.9275 1.5 30.9924 5.43496 30.9924 10.2891C30.9924 12.0889 31.5338 13.762 32.4621 15.1554L31.4807 18.5898L34.9153 17.6085C36.3085 18.5367 37.9817 19.0781 39.7815 19.0781C44.6355 19.0781 48.5706 15.1432 48.5706 10.2891C48.5706 5.43496 44.6355 1.5 39.7815 1.5Z",
    stroke: "#43768A",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.0beea774f855459a3af9ca439a067afb.svg";
export { ForwardRef as ReactComponent };